import React from "react";

const DragHandlerIcon = ({ ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13.001" viewBox="0 0 11 13.001" {...props}>
    <path id="Union_340" data-name="Union 340" d="M1.5,13a1.5,1.5,0,0,1,0-3h8a1.5,1.5,0,0,1,0,3Zm0-5a1.5,1.5,0,1,1,0-3h8a1.5,1.5,0,1,1,0,3Zm0-5a1.5,1.5,0,1,1,0-3h8a1.5,1.5,0,1,1,0,3Z" fill="#707070"/>
  </svg>
);

export default React.memo(DragHandlerIcon);